import { Modal, PillButton, Row, Stack, Text } from 'library/ui';
import React from 'react';

export default function DocumentDownloadInfo({
    showDocDownloadInfo,
    setShowDocDownloadInfo,
}: {
    showDocDownloadInfo: boolean;
    setShowDocDownloadInfo: (show: boolean) => void;
}) {
    if (!showDocDownloadInfo) {
        return null;
    }

    return (
        <Modal title="Heads up!" onClose={() => setShowDocDownloadInfo(false)} width={600}>
            <Stack gap="md">
                <Text>
                    It looks like this worker is new to your site! You&apos;ll find a completed 718-B-DC in this
                    worker&apos;s document file. To receive clearance for this worker to work in your program,
                    you&apos;ll need to file the attached 718-B-DC form with DCFS as soon as possible. Tandem provides
                    you with the documentation you need — but it is the center&apos;s responsibility to file the
                    718-B-DC.
                </Text>
                <Row justify="end" fullWidth>
                    <PillButton onClick={() => setShowDocDownloadInfo(false)}>Close</PillButton>
                </Row>
            </Stack>
        </Modal>
    );
}
